import ReportRequests from "components/reports-common/report-requests/report-requests";


export default function ReportRequestsIndex() {

    return (
        <ReportRequests />
    );
}
